// import React, { useState, useEffect, useMemo } from 'react';
// import Card from '../../components/common/Card/Card';
// import Button from '../../components/common/Button/Button';
// import Table from '../../components/common/Table/Table';
// import Modal from '../../components/common/Modal/Modal';
// import LoadingSpinner from '../../components/common/LoadingSpinner/LoadingSpinner';
// import SearchBar from '../../components/common/SearchBar/SearchBar';
// import { getAllStudents, createStudent, deleteStudent, suspendStudent, unsuspendStudent } from '../../services/studentService';
// import useForm from '../../hooks/useForm';
// import useAuth from '../../hooks/useAuth';
// import styles from './Students.module.css';

// const Students = () => {
//   const { user } = useAuth();
//   const isSuperAdmin = user?.role === 'super_admin';
//   const [students, setStudents] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showModal, setShowModal] = useState(false);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [showCredentials, setShowCredentials] = useState(null);


//   useEffect(() => {
//     fetchStudents();
//   }, []);

//   const fetchStudents = async () => {
//     try {
//       const data = await getAllStudents();
//       setStudents(data);
//     } catch (error) {
//       console.error('Error fetching students:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const { values, handleChange, handleSubmit, resetForm , isSubmitting} = useForm(
//     {
//       first_name: '',
//       last_name: '',
//       email: '',
//       phone: '',
//       school: '',
//       graduation_year: new Date().getFullYear() + 1,
//       program_enrolled: '',
//       field_interest_tags: [],
//       college_aspirations_major: '',
//       college_aspirations_region: '',
//       project_themes_interested: [],
//       board_curriculum: '',
//       city: '',
//       country: '',
//       parent_name: '',
//       parent_email: '',
//       parent_phone: '',
//       shipping_address: '',
//       competitions_suggested: [],
//       competitions_won: [],
//       associated_counsellor: ''
//     },
//     async (formValues) => {
//       try {
//         await createStudent(formValues);
//         setShowModal(false);
//         resetForm();
//         fetchStudents();
//       } catch (error) {
//         alert('Error creating student: ' + error.message);
//       }
//     }
//   );

//   const handleDelete = async (studentId) => {
//     if (window.confirm('Are you sure you want to delete this student?')) {
//       try {
//         await deleteStudent(studentId);
//         fetchStudents();
//       } catch (error) {
//         alert('Error deleting student: ' + error.message);
//       }
//     }
//   };

//   const handleSuspend = async (userId, isSuspended) => {
//     const action = isSuspended ? 'unsuspend' : 'suspend';
//     const confirmMessage = isSuspended 
//       ? 'Are you sure you want to unsuspend this student? They will be able to login again.'
//       : 'Are you sure you want to suspend this student? They will not be able to login.';
    
//     if (window.confirm(confirmMessage)) {
//       try {
//         if (isSuspended) {
//           await unsuspendStudent(userId);
//         } else {
//           await suspendStudent(userId, 'Suspended by administrator');
//         }
//         fetchStudents();
//         alert(`Student ${action}ed successfully`);
//       } catch (error) {
//         alert(`Error ${action}ing student: ${error.message}`);
//       }
//     }
//   };

//   // Filter students based on search query
//   const filteredStudents = useMemo(() => {
//     if (!searchQuery) return students;
    
//     const query = searchQuery.toLowerCase();
//     return students.filter(student => {
//       const fullName = `${student.first_name} ${student.last_name}`.toLowerCase();
//       const email = student.email?.toLowerCase() || '';
//       return fullName.includes(query) || email.includes(query);
//     });
//   }, [students, searchQuery]);

//   const columns = [
//     { 
//       header: 'Name', 
//       accessor: 'first_name',
//       sortKey: 'first_name',
//       sortValue: (row) => `${row.first_name} ${row.last_name}`,
//       render: (row) => (
//         <div>
//           {`${row.first_name} ${row.last_name}`}
//           {row.is_suspended && <span style={{ marginLeft: '8px', padding: '2px 8px', fontSize: '11px', background: '#ff9800', color: 'white', borderRadius: '4px', fontWeight: 'bold' }}>SUSPENDED</span>}
//         </div>
//       )
//     },
//     { header: 'Email', accessor: 'email' },
//     { header: 'School', accessor: 'school', sortable: false },
//     { header: 'Graduation Year', accessor: 'graduation_year', sortable: false },
//     { header: 'City', accessor: 'city', sortable: false },
//     { header: 'Parent Name', accessor: 'parent_name', sortable: false },
//     ...(isSuperAdmin ? [{ 
//       header: 'Actions',
//       sortable: false,
//       render: (row) => (
//         <div style={{ display: 'flex', gap: '8px' }}>
//           <Button //             size="small" 
//             variant={row.is_suspended ? 'primary' : 'warning'} 
//             onClick={() => handleSuspend(row.user_id, row.is_suspended)} loading={loading}
//             style={{ 
//               backgroundColor: row.is_suspended ? '#4CAF50' : '#FF9800',
//               minWidth: '90px'
//             }}
//           >
//             {row.is_suspended ? 'Unsuspend' : 'Suspend'}
//           </Button>
//           <Button size="small" variant="danger" onClick={() => handleDelete(row.id)} loading={loading}>
//             Delete
//           </Button>
//         </div>
//       )
//     }] : [])
//   ];

//   if (loading) {
//     return <div className={styles.loading}><LoadingSpinner /></div>;
//   }

//   return (
//     <div className={styles.studentsPage}>
//       <div className={styles.header}>
//         <h1>Students</h1>
//         <div className={styles.headerActions}>
//           <SearchBar 
//             value={searchQuery}
//             onChange={setSearchQuery}
//             placeholder="Search students by name or email..."
//           />
//           <Button icon="+" onClick={() => setShowModal(true)} loading={loading}>Add Student</Button>
//         </div>
//       </div>

//       <Card>
//         <Table columns={columns} data={filteredStudents} />
//       </Card>

//       <Modal isOpen={showModal} onClose={() => setShowModal(false)} title="Add New Student" size="large">
//         <form onSubmit={handleSubmit} className={styles.form}>
//           <h3 className={styles.sectionTitle}>Student Information</h3>
//           <div className={styles.formGrid}>
//             <div className={styles.formGroup}>
//               <label>First Name *</label>
//               <input name="first_name" value={values.first_name} onChange={handleChange} required />
//             </div>
//             <div className={styles.formGroup}>
//               <label>Last Name *</label>
//               <input name="last_name" value={values.last_name} onChange={handleChange} required />
//             </div>
//             <div className={styles.formGroup}>
//               <label>Email *</label>
//               <input type="email" name="email" value={values.email} onChange={handleChange} required />
//             </div>
//             <div className={styles.formGroup}>
//               <label>Phone *</label>
//               <input name="phone" value={values.phone} onChange={handleChange} required />
//             </div>
//             <div className={styles.formGroup}>
//               <label>School</label>
//               <input name="school" value={values.school} onChange={handleChange} />
//             </div>
//             <div className={styles.formGroup}>
//               <label>Graduation Year</label>
//               <input type="number" name="graduation_year" value={values.graduation_year} onChange={handleChange} />
//             </div>
//             <div className={styles.formGroup}>
//               <label>Board/Curriculum</label>
//               <input name="board_curriculum" value={values.board_curriculum} onChange={handleChange} placeholder="IB, CBSE, ICSE, AP" />
//             </div>
//             <div className={styles.formGroup}>
//               <label>Program Enrolled</label>
//               <input name="program_enrolled" value={values.program_enrolled} onChange={handleChange} />
//             </div>
//             <div className={styles.formGroup}>
//               <label>City</label>
//               <input name="city" value={values.city} onChange={handleChange} />
//             </div>
//             <div className={styles.formGroup}>
//               <label>Country</label>
//               <input name="country" value={values.country} onChange={handleChange} />
//             </div>
//             <div className={styles.formGroup}>
//               <label>College Aspirations (Major)</label>
//               <input name="college_aspirations_major" value={values.college_aspirations_major} onChange={handleChange} />
//             </div>
//             <div className={styles.formGroup}>
//               <label>College Aspirations (Region)</label>
//               <input name="college_aspirations_region" value={values.college_aspirations_region} onChange={handleChange} />
//             </div>
//           </div>

//           <h3 className={styles.sectionTitle}>Parent Information</h3>
//           <div className={styles.formGrid}>
//             <div className={styles.formGroup}>
//               <label>Parent Name</label>
//               <input name="parent_name" value={values.parent_name} onChange={handleChange} />
//             </div>
//             <div className={styles.formGroup}>
//               <label>Parent Email</label>
//               <input type="email" name="parent_email" value={values.parent_email} onChange={handleChange} />
//             </div>
//             <div className={styles.formGroup}>
//               <label>Parent Phone</label>
//               <input name="parent_phone" value={values.parent_phone} onChange={handleChange} />
//             </div>
//             <div className={styles.formGroup}>
//               <label>Associated Counsellor</label>
//               <input name="associated_counsellor" value={values.associated_counsellor} onChange={handleChange} />
//             </div>
//           </div>

//           <div className={styles.formGroup}>
//             <label>Shipping Address</label>
//             <textarea name="shipping_address" value={values.shipping_address} onChange={handleChange} rows="2" />
//           </div>

//           <div className={styles.formActions}>
//             <Button type="button" variant="outline" onClick={() => setShowModal(false)} loading={loading}>Cancel</Button>
//             <Button type="submit" loading={isSubmitting}>Create Student</Button>
//           </div>
//         </form>
//       </Modal>
//     </div>
//   );
// };

// export default Students;

import React, { useState, useEffect, useMemo } from 'react';
import Card from '../../components/common/Card/Card';
import Button from '../../components/common/Button/Button';
import Table from '../../components/common/Table/Table';
import Modal from '../../components/common/Modal/Modal';
import LoadingSpinner from '../../components/common/LoadingSpinner/LoadingSpinner';
import SearchBar from '../../components/common/SearchBar/SearchBar';
import { getAllStudents, createStudent, deleteStudent, suspendStudent, unsuspendStudent } from '../../services/studentService';
import useForm from '../../hooks/useForm';
import useAuth from '../../hooks/useAuth';
import { useToast, useConfirm } from '../../context/ToastContext';
import styles from './Students.module.css';

const Students = () => {
  const { user } = useAuth();
  const isSuperAdmin = user?.role === 'super_admin';
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [showCredentials, setShowCredentials] = useState(null);
  const toast = useToast();
  const confirm = useConfirm();

  useEffect(() => {
    fetchStudents();
  }, []);

  const fetchStudents = async () => {
    try {
      const data = await getAllStudents();
      setStudents(data);
    } catch (error) {
      console.error('Error fetching students:', error);
    } finally {
      setLoading(false);
    }
  };

  const { values, handleChange, handleSubmit, resetForm , isSubmitting} = useForm(
    {
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      school: '',
      graduation_year: new Date().getFullYear() + 1,
      program_enrolled: '',
      field_interest_tags: [],
      college_aspirations_major: '',
      college_aspirations_region: '',
      project_themes_interested: [],
      board_curriculum: '',
      city: '',
      country: '',
      comp_ai_country: '',
      parent_name: '',
      parent_email: '',
      parent_phone: '',
      shipping_address: '',
      competitions_suggested: [],
      competitions_won: [],
      associated_counsellor: ''
    },
    async (formValues) => {
      try {
        const result = await createStudent(formValues);
        setShowCredentials(result.credentials);
        setShowModal(false);
        resetForm();
        fetchStudents();
      } catch (error) {
        toast.error('Error creating student: ' + error.message);
      }
    }
  );

  const handleDelete = async (studentId) => {
    const confirmed = await confirm('Are you sure you want to delete this student?', { confirmText: 'Delete', variant: 'danger' });
    if (confirmed) {
      try {
        await deleteStudent(studentId);
        fetchStudents();
      } catch (error) {
        toast.error('Error deleting student: ' + error.message);
      }
    }
  };

  const handleSuspend = async (userId, isSuspended) => {
    const action = isSuspended ? 'unsuspend' : 'suspend';
    const confirmMessage = isSuspended
      ? 'Are you sure you want to unsuspend this student? They will be able to login again.'
      : 'Are you sure you want to suspend this student? They will not be able to login.';

    const confirmed = await confirm(confirmMessage, { confirmText: isSuspended ? 'Unsuspend' : 'Suspend', variant: 'warning' });
    if (confirmed) {
      try {
        if (isSuspended) {
          await unsuspendStudent(userId);
        } else {
          await suspendStudent(userId, 'Suspended by administrator');
        }
        fetchStudents();
        toast.success(`Student ${action}ed successfully`);
      } catch (error) {
        toast.error(`Error ${action}ing student: ${error.message}`);
      }
    }
  };

  const filteredStudents = useMemo(() => {
    if (!searchQuery) return students;

    const query = searchQuery.toLowerCase();
    return students.filter(student => {
      const fullName = `${student.first_name} ${student.last_name}`.toLowerCase();
      const email = student.email?.toLowerCase() || '';
      return fullName.includes(query) || email.includes(query);
    });
  }, [students, searchQuery]);

  const columns = [
    {
      header: 'Name',
      accessor: 'first_name',
      sortKey: 'first_name',
      sortValue: (row) => `${row.first_name} ${row.last_name}`,
      render: (row) => (
        <div>
          {`${row.first_name} ${row.last_name}`}
          {row.is_suspended && (
            <span
              style={{
                marginLeft: '8px',
                padding: '2px 8px',
                fontSize: '11px',
                background: '#ff9800',
                color: 'white',
                borderRadius: '4px',
                fontWeight: 'bold'
              }}
            >
              SUSPENDED
            </span>
          )}
        </div>
      )
    },
    { header: 'Email', accessor: 'email' },
    { header: 'School', accessor: 'school', sortable: false },
    { header: 'Graduation Year', accessor: 'graduation_year', sortable: false },
    { header: 'City', accessor: 'city', sortable: false },
    { header: 'Parent Name', accessor: 'parent_name', sortable: false },
    ...(isSuperAdmin
      ? [{
        header: 'Actions',
        sortable: false,
        render: (row) => (
          <div style={{ display: 'flex', gap: '8px' }}>
            <Button size="small"
              variant={row.is_suspended ? 'primary' : 'warning'}
              onClick={() => handleSuspend(row.user_id, row.is_suspended)} loading={loading}
              style={{
                backgroundColor: row.is_suspended ? '#4CAF50' : '#FF9800',
                minWidth: '90px'
              }}
            >
              {row.is_suspended ? 'Unsuspend' : 'Suspend'}
            </Button>
            <Button size="small" variant="danger" onClick={() => handleDelete(row.id)} loading={loading}>
              Delete
            </Button>
          </div>
        )
      }]
      : [])
  ];

  if (loading) {
    return <div className={styles.loading}><LoadingSpinner /></div>;
  }

  return (
    <div className={styles.studentsPage}>
      <div className={styles.header}>
        <h1>Students</h1>
        <div className={styles.headerActions}>
          <SearchBar
            value={searchQuery}
            onChange={setSearchQuery}
            placeholder="Search students by name or email..."
          />
          <Button icon="+" onClick={() => setShowModal(true)} loading={loading}>Add Student</Button>
        </div>
      </div>

      <Card>
        <Table columns={columns} data={filteredStudents} />
      </Card>

      <Modal isOpen={showModal} onClose={() => setShowModal(false)} title="Add New Student" size="large">
        <form onSubmit={handleSubmit} className={styles.form}>
          <h3 className={styles.sectionTitle}>Student Information</h3>
          <div className={styles.formGrid}>
            <div className={styles.formGroup}>
              <label>First Name *</label>
              <input name="first_name" value={values.first_name} onChange={handleChange} required />
            </div>
            <div className={styles.formGroup}>
              <label>Last Name *</label>
              <input name="last_name" value={values.last_name} onChange={handleChange} required />
            </div>
            <div className={styles.formGroup}>
              <label>Email *</label>
              <input type="email" name="email" value={values.email} onChange={handleChange} required />
            </div>
            <div className={styles.formGroup}>
              <label>Phone *</label>
              <input name="phone" value={values.phone} onChange={handleChange} required />
            </div>
            <div className={styles.formGroup}>
              <label>School</label>
              <input name="school" value={values.school} onChange={handleChange} />
            </div>
            <div className={styles.formGroup}>
              <label>Graduation Year</label>
              <input type="number" name="graduation_year" value={values.graduation_year} onChange={handleChange} />
            </div>
            <div className={styles.formGroup}>
              <label>Board/Curriculum</label>
              <input name="board_curriculum" value={values.board_curriculum} onChange={handleChange} placeholder="IB, CBSE, ICSE, AP" />
            </div>
            <div className={styles.formGroup}>
              <label>Program Enrolled</label>
              <input name="program_enrolled" value={values.program_enrolled} onChange={handleChange} />
            </div>
            <div className={styles.formGroup}>
              <label>City</label>
              <input name="city" value={values.city} onChange={handleChange} />
            </div>
            <div className={styles.formGroup}>
              <label>Country</label>
              <input name="country" value={values.country} onChange={handleChange} />
            </div>
            <div className={styles.formGroup}>
              <label>COMP_AI COUNTRY NAME *</label>
              <select
                name="comp_ai_country"
                value={values.comp_ai_country}
                onChange={handleChange}
                required
              >
                <option value="">-- Select a Country --</option>
                <option value="India">INDIA</option>
                <option value="USA">USA</option>
                <option value="Worldwide">OTHER COUNTRY (WORLDWIDE)</option>
              </select>
              <small style={{ color: '#666', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                Which region's competitions this student is matched against.
              </small>
            </div>
            <div className={styles.formGroup}>
              <label>College Aspirations (Major)</label>
              <input name="college_aspirations_major" value={values.college_aspirations_major} onChange={handleChange} />
            </div>
            <div className={styles.formGroup}>
              <label>College Aspirations (Region)</label>
              <input name="college_aspirations_region" value={values.college_aspirations_region} onChange={handleChange} />
            </div>
          </div>

          <h3 className={styles.sectionTitle}>Parent Information</h3>
          <div className={styles.formGrid}>
            <div className={styles.formGroup}>
              <label>Parent Name</label>
              <input name="parent_name" value={values.parent_name} onChange={handleChange} />
            </div>
            <div className={styles.formGroup}>
              <label>Parent Email</label>
              <input type="email" name="parent_email" value={values.parent_email} onChange={handleChange} />
            </div>
            <div className={styles.formGroup}>
              <label>Parent Phone</label>
              <input name="parent_phone" value={values.parent_phone} onChange={handleChange} />
            </div>
            <div className={styles.formGroup}>
              <label>Associated Counsellor</label>
              <input name="associated_counsellor" value={values.associated_counsellor} onChange={handleChange} />
            </div>
          </div>

          <div className={styles.formGroup}>
            <label>Shipping Address</label>
            <textarea name="shipping_address" value={values.shipping_address} onChange={handleChange} rows="2" />
          </div>

          <div className={styles.formActions}>
            <Button type="button" variant="outline" onClick={() => setShowModal(false)} loading={loading}>Cancel</Button>
            <Button type="submit" loading={isSubmitting}>Create Student</Button>
          </div>
        </form>
      </Modal>

      {showCredentials && (
        <Modal isOpen={!!showCredentials} onClose={() => setShowCredentials(null)} title="Student Credentials">
          <div className={styles.credentials}>
            {showCredentials.username && (
              <p><strong>Username:</strong> {showCredentials.username}</p>
            )}
            <p><strong>Email:</strong> {showCredentials.email}</p>
            <p><strong>Password:</strong> {showCredentials.password}</p>
            <p className={styles.warning}>Alert: Please save these credentials securely. They will not be shown again.</p>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default Students;
